import _ from 'lodash';
import update from 'immutability-helper';
import React, { PropTypes } from 'react';
import Fuse from 'fuse.js';
import FontAwesome from 'react-fontawesome';
import classNames from 'classnames';
import DragMember from './DragMember';
import { SelectableGroup, createSelectable } from 'react-selectable';
import SortBy from '../../../components/common/SortBy';
import * as SortByUtils from '../../../components/common/sortByUtils';
import FilterBy from '../../../components/common/FilterBy';
import * as FilterByUtils from '../../../components/common/filterByUtils';

const SelectableDragMember = createSelectable(DragMember);

class RegMemberList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.searchUpdate = this.searchUpdate.bind(this);
    this.addToSelected = this.addToSelected.bind(this);
    this.selectOrClear = this.selectOrClear.bind(this);
    this.handleDragSelection = this.handleDragSelection.bind(this);
    this.clearSelected = this.clearSelected.bind(this);
    this.sortUpdate = this.sortUpdate.bind(this);
    this.filterUpdate = this.filterUpdate.bind(this);
    this.toggle = this.toggle.bind(this);
    this.state = {
      searchTerm: "",
      selectedMembers: [],
      showSortOptions: false,
      showFilter: false,
      showSearch: true,
      sortOptions: [
        {value: 'member_details.first_name', label: 'Fornavn'},
        {value: 'member_details.last_name', label: 'Etternavn'},
        {value: 'member_details.birth_date', label: 'Fødselsdag'}
      ],
      sortedBy: '',
      sortedByDir: '',
      filterBy: undefined,
    };
  }

  toggle(part) {
    this.setState({
      [part]: !this.state[part]
    });
  }

  searchUpdate(e) {
    let term = e.target.value;
    this.setState({
      searchTerm: term
    });
  }

  filterUpdate(value) {
    this.setState({
      filterBy: value
    });
  }

  sortUpdate(value) {
    let newState = SortByUtils.updateSortedBy(value,
      this.state.sortedBy,
      this.state.sortedByDir);
    this.setState(newState);
  }

  addToSelected(member) {
    let index = _.findIndex(this.state.selectedMembers, {id: member.id});
    let selectedMembers = this.state.selectedMembers;
    if (index == -1) {
      selectedMembers = update(selectedMembers, {$push: [member]});
    } else {
      selectedMembers = update(selectedMembers, {$splice: [[index, 1]]});
    }
    this.setState({
      selectedMembers: selectedMembers
    });
  }

  selectOrClear() {
    if (!_.size(this.state.selectedMembers)) {
      this.setState({
        selectedMembers: this.props.list,
      });
    } else {
      this.clearSelected();
    }
  }

  clearSelected() {
    this.setState({
      selectedMembers: [],
    });
  }

  handleDragSelection (selected, ev, ev2) {
    // console.log(ev, ev2);
    if (ev.shiftKey) {
      let resultSelected = _.union(selected, this.state.selectedMembers)
      this.setState({ selectedMembers: resultSelected });
    } else {
      this.setState({ selectedMembers: selected });
    }
  }

  render () {
    let memberList = _.sortBy(this.props.list, [
      'member_details.first_name',
      'member_details.last_name'
    ]);
    if(this.state.sortedBy) {
      memberList = SortByUtils.sortBy(memberList, this.state.sortedBy, this.state.sortedByDir)
    }
    if(this.state.filterBy) {
      memberList = FilterByUtils.filterBy(this.state.filterBy, memberList, this.props.registeredMembers)
    }
    if(this.state.searchTerm) {
      let search = new Fuse((memberList),{
        keys: ["member_details.first_name", "member_details.last_name"]
        });
      memberList = search.search(this.state.searchTerm);
    }
    return (
      <div className="panel panel-default">
        <div className="panel-heading clearfix">
          <h5 className="pull-left">Fordel deltagere</h5>
          <div className="pull-right">
            <a className={classNames("btn", {
                'btn-default': !this.state.showSearch,
                'btn-info': this.state.showSearch,
                'btn-warning': this.state.searchTerm,
              })}
              onClick={() => {
                this.toggle('showSearch');
              }}>
              <FontAwesome name="search" />
            </a>
            {!this.props.uniqueTeamMembers && <span>
              &nbsp;
              <a className={classNames("btn", {
                  'btn-default': !this.state.showFilter,
                  'btn-info': this.state.showFilter,
                  'btn-warning': this.state.filterBy,
                })}
                onClick={() => {
                  this.toggle('showFilter');
                }}>
                <FontAwesome name="filter" />
              </a>
            </span>}
            &nbsp;
            <a className={classNames("btn", {
                'btn-default': !this.state.showSortOptions,
                'btn-info': this.state.showSortOptions,
                'btn-warning': this.state.sortedBy,
              })}
              onClick={() => {
                this.toggle('showSortOptions');
              }}>
              <FontAwesome name="sort-amount-asc" />
            </a>
            &nbsp;
            <a className="btn btn-default"
              onClick={() => {
                this.selectOrClear();
              }}>
              <FontAwesome name="check-square-o" />
            </a>
          </div>
        </div>
        <div className="panel-body member-reg-search">
          {this.state.showSearch &&  <div className="list-interface-item">
            <div className="input-group">
              <span className="input-group-addon" id="basic-addon3">
                <FontAwesome
                  name="search" />
              </span>
              <input
                type="search"
                className="form-control"
                onChange={this.searchUpdate}
                value={this.state.searchTerm}
                />
            </div>
          </div>}
          {this.state.showSortOptions && <div className="list-interface-item">
            <SortBy
              sortedBy={this.state.sortedBy}
              sortedByDir={this.state.sortedByDir}
              sortOptions={this.state.sortOptions}
              updateCB={this.sortUpdate}
               />
          </div>}
          {this.state.showFilter && <div className="list-interface-item">
            <FilterBy
              filterBy={this.state.filterBy}
              updateCB={this.filterUpdate}
               />
          </div>}
        </div>
        <div className="member-reg-search-divider" />
        <div className="panel-body registration-list">
          <SelectableGroup onSelection={this.handleDragSelection} tolerance={10}>
            {memberList.map((memberReg) => {
              let selected = (
                _.findIndex(this.state.selectedMembers, {id: memberReg.id}) != -1
              );
              return (
                <SelectableDragMember
                  key={memberReg.identifier}
                  member={memberReg}
                  list={this.props.list}
                  clearSelected={this.clearSelected}
                  selected={selected}
                  selectableKey={memberReg}
                  selectedMembers={this.state.selectedMembers}
                  addToSelected={this.addToSelected}
                  />
              );
            })}
          </SelectableGroup>
          {!this.props.list.length && <div className="alert alert-info">
            Ingen fler deltagere.
          </div>}
        </div>
      </div>
    );
  }
}

RegMemberList.propTypes = {
  list: PropTypes.array,
  allMembers: PropTypes.array,
  defaultFilter: PropTypes.array,
  uniqueTeamMembers: PropTypes.bool,
};

export default RegMemberList;



/** WEBPACK FOOTER **
 ** ./src/containers/events/register/RegMemberList.js
 **/